module.exports = __webpack_public_path__ + "assets/img/logo2.4951203f.png";